<div class="{{theme}}">
    <button mat-icon-button class="close-button" (click)="save()" [mat-dialog-close]="true">
        <mat-icon class="close-icon">close</mat-icon>
    </button>

    <mat-dialog-content>
        <div class="mt-3 mr-0">
            <div class="row">
                <div class="col-12">
                    <mat-label>Category :</mat-label>
                    <mat-radio-group (change)="updateDraftMessage()" aria-label="Category" class="tp-radio-group" [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="this.draftCategory">
                        <mat-radio-button value="underMaintenance">Under Maintenance</mat-radio-button>
                        <mat-radio-button value="comingSoon">Coming Soon</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <div class="row mt-1">
                <div class="col-3">
                    <mat-label>Message :</mat-label>
                </div>
                <div class="col-12 mt-1">
                    <textarea maxlength="100" class="mat-textarea" matInput [(ngModel)]="this.draftMessage" placeholder="Message" [required]="true"> </textarea>
                    <mat-error *ngIf="this.isSubmitted && this.draftMessage.trim() === '' ">Message is Required</mat-error>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div id="admin" class="row mt-3 mx-auto">
            <span class="save-btn">
                <button type="button" class="btn btn-default btn-save" (click)="save()">Save As Draft</button>
            </span>
            <span class="ml-2">
                <button type="button" class="btn btn-secondary" [mat-dialog-close]="true">{{ "Button.cancel" | translate}}</button>
            </span>
        </div>
    </mat-dialog-actions>
</div>